import { Component } from '@angular/core';
import { AuthenticationService, OrderService } from '@app/_services';
import { Address } from '@interfaces/address';
import { Order } from '@interfaces/order';
import { addresses } from '../../../../../data/account-addresses';
import { orders } from '../../../../../data/account-orders';
import { Pagination } from '@app/_interfaces/pagination.interface';
import * as _ from 'lodash'
import { RouterLink } from '@angular/router';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-page-loyalty',
    templateUrl: './page-loyalty.component.html',
    styleUrls: ['./page-loyalty.component.sass'],
    standalone: true,
    imports: [NgIf, NgFor, RouterLink, DatePipe]
})
export class PageLoyaltyComponent {
    constructor(private authService: AuthenticationService,
        private orderService: OrderService) { }
    address;
    orders;
    userDetails;
    pagination: Pagination = {
        page: 1,
        limit: 3
    };
    ngOnInit(): void {

        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });

        this.orderService.getAll(this.pagination).subscribe((response) => {
            this.orders = response.data;
        });
    }
}
